import { createElement } from 'react';

interface FormaToolbarButtonProps extends React.HTMLAttributes<HTMLElement> {
  className?: string;
  label?: string;
  shortcut?: string;
  active?: boolean;
  disabled?: boolean;
  change?: (event: Event) => void;
}

export function FormaToolbarButton({
  className,
  label,
  shortcut,
  active,
  disabled,
  change,
  children,
  ...rest
}: FormaToolbarButtonProps) {
  return createElement(
    'forma-toolbar-button',
    {
      className,
      label,
      shortcut,
      active,
      disabled,
      onChange: change,
      ...rest,
    },
    children
  );
}
